export default __webpack_public_path__ + "static/media/traingle.e09c1851.jpg";